import { Dropdown, MenuProps } from 'antd';
import { FileOutlined, FolderOutlined, PlusOutlined } from '@ant-design/icons';
import { DocumentView } from './DocumentView';
import { DocumentModal } from '@/utils/enums';
import TreeView from '@/components/folders/TreeView';
import styles from '@/styles/documents.module.css';
import { useTranslation } from 'react-i18next';
import { User } from '@/types';
import { canUploadFileToFolder, canUploadToFolder } from '@/utils/helpers';

export default function LeftSidebar({
  navWidth,
  documentView,
  currentNode,
  expandedKeys,
  onExpand,
  onFolderNameClick,
  setOpenModal,
  user,
}: {
  navWidth: number;
  documentView: DocumentView;
  currentNode: any;
  expandedKeys: string[];
  onExpand: any;
  onFolderNameClick?: (node: any) => void;
  setOpenModal: any;
  user: User | null;
}) {
  const { t } = useTranslation();
  const canAddFolderAtCurrentNode = canUploadToFolder(user, currentNode);
  const canAddFileAtCurrentNode = canUploadFileToFolder(user, currentNode);

  const items: MenuProps['items'] = [
    {
      key: '1',
      disabled: !canAddFolderAtCurrentNode,
      label: (
        <div
          className={styles.dropdownOptions}
          onClick={() => {
            setOpenModal(DocumentModal.ADD_FOLDER);
          }}
        >
          <FolderOutlined />
          {t('home.documents.addFolder')}
        </div>
      ),
    },
    {
      key: '2',
      disabled: !canAddFileAtCurrentNode,
      label: (
        <div
          className={styles.dropdownOptions}
          onClick={() => {
            setOpenModal(DocumentModal.ADD_FILE);
          }}
        >
          <FileOutlined />
          {t('home.documents.addFile')}
        </div>
      ),
    },
  ];

  const getMenuItems = (isDefault: boolean = true, node: any): any => {
    if (!isDefault) {
      return items.map(item => ({
        ...item,
        disabled:
          item?.key === '2'
            ? !canUploadFileToFolder(user, node)
            : !canUploadToFolder(user, node),
      }));
    }
    return items;
  };

  return (
    <div>
      <div className={styles.leftSideBar}>
        <b>{t('home.documents.folderTitle')}</b>
        <Dropdown menu={{ items }} trigger={['click']}>
          <div
            className={`${styles.dropdown} ${currentNode?.isLeaf ? 'disabled' : ''}`}
          >
            <PlusOutlined /> {t('home.documents.btnAdd')}
          </div>
        </Dropdown>
      </div>
      <TreeView
        width={navWidth}
        documentView={documentView}
        currentNode={currentNode}
        setOpenModal={setOpenModal}
        expandedKeys={expandedKeys}
        onExpand={onExpand}
        onFolderNameClick={onFolderNameClick}
        items={getMenuItems}
      />
    </div>
  );
}
